<template>
  <v-select
    :class="{
      [additionalClass]: additionalClass
    }"
    :solo="solo"
    v-model="selectedItem"
    :items="items"
    :background-color="bgColor"
    :item-text="itemText"
    :item-value="itemValue"
    :label="label"
    :return-object="returnObject"
    :single-line="singleLine"
    :dense="dense"
    :disabled="disabled"
    :attach="attach"
    hide-details="auto"
  />
</template>
<script>
export default {
  name: 'select-box',

  props: {
    /**
     * @items items to show in select box list
     */
    items: {
      type: Array,
      required: true
    },
    /**
     * items can have multiple keys,
     * to show one key to user which he/she can understand to select item, that will be defined as @itemValue
     * and another key to be store in @selectedItem , that wlll be defined as @itemText
     */
    itemValue: {
      type: String
    },
    itemText: {
      type: String
    },
    /**
     * @label placeholder that will be shown when no item is selected
     */
    label: {
      type: String,
      default: ''
    },
    bgColor: {
      type: String,
      default: '#E5E5E5'
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    singleLine: {
      type: Boolean,
      default: false
    },
    /**
     * @additionalClass classes for more customizations
     */
    additionalClass: {
      type: String
    },
    solo: {
      type: Boolean,
      default: false
    },
    /**
     * You can use @dense prop to reduce the field height and lower max height of list items.
     */
    dense: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      default: null
    },
    attach: {
      default: ''
    }
  },

  model: {
    prop: 'value',
    event: 'input'
  },

  data() {
    return {};
  },

  computed: {
    selectedItem: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },

  mounted() {},

  methods: {}
};
</script>
